import React, { createContext, useContext } from 'react';
import { n as noop } from './noop-BzN7sYrl.js';

const defaultValues = {
    title: "",
    data: [],
    headers: {},
    children: [],
    selected: [],
    layoutBreakpoints: [],
    layouts: {
        xs: children => React.createElement(React.Fragment, null, children),
        sm: children => React.createElement(React.Fragment, null, children),
        md: children => React.createElement(React.Fragment, null, children),
        lg: children => React.createElement(React.Fragment, null, children),
        xl: children => React.createElement(React.Fragment, null, children),
    },
    registerLayout: noop,
};
const DataListContext = createContext(defaultValues);
function useDataListContext() {
    return useContext(DataListContext);
}

export { DataListContext as D, defaultValues as d, useDataListContext as u };
